import styled from 'styled-components';

import * as MUI from '@mui/material';
import { Theme } from '../Theme';

export const Popover = styled(MUI.Popover)``;

export const PopoverTitle = styled.div`
	padding: 0.75rem 1rem;
	font-size: 14px;
	font-weight: bold;
	line-height: 18px;
`;

export const PopoverBody = styled.div`
	min-height: 100px;
	max-height: 300px;
	padding: 0;
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 8px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: ${Theme.scrollThumb};
	}
`;

export const PopoverItem = styled(MUI.MenuItem)`
	gap: 8px !important;
	min-width: 8rem !important;
	padding: 0.5rem 0.5rem !important;
	margin: 0 0.5rem !important;
	border-bottom: 0.5px solid ${Theme.lightGrey} !important;
	font-size: 12px !important;
	font-weight: 400 !important;
	line-height: 20px !important;
	text-transform: uppercase !important;
`;
